// Row / polygon / legend styling per parcel state. Theme classes come from storage/static/css/style.css.
export const STATES = {
    subject: { label: "amas:analysis:pra:state_subject", theme: "primary", color: "#707cd2", dashArray: null },
    building_land: { label: "amas:analysis:pra:state_building_land", theme: "primary", color: "#707cd2", dashArray: null },
    passable: { label: "amas:analysis:pra:state_passable", theme: "success", color: "#53e69d", dashArray: null },
    physical_only: { label: "amas:analysis:pra:state_physical_only", theme: "warning", color: "#ffc36d", dashArray: "6 4" },
    road: { label: "amas:analysis:pra:state_road", theme: "info", color: "#2cabe3", dashArray: null },
    off_route: { label: "amas:analysis:pra:state_off_route", theme: "default", color: "#e4e7ea", dashArray: null, rowColor: "#c5cad0", hidePill: true },
};

export const STATE_ORDER = ["subject", "building_land", "passable", "physical_only", "road", "off_route"];

// routeStates: the server's state of every parcel on a route to a road, by id; checked parcels off every route stay grey.
export function stateOf(entry, routeStates) {
    if (!entry) { return "off_route"; }
    if (entry.depth === 0) { return entry.building_land ? "building_land" : "subject"; }
    const state = (routeStates || {})[entry.property_id];
    return STATES[state] ? state : "off_route";
}

export function polygonStyle(key) {
    const state = STATES[key] || STATES.off_route;
    return {
        color: state.color,
        edgeColor: key === "off_route" ? "#8a929c" : state.color,
        stroke: true,
        weight: state.dashArray ? 2 : 3,
        fillOpacity: key === "off_route" ? 0.35 : 0.7,
        dashArray: state.dashArray || undefined,
    };
}

export function legendEntries(t, withBuildingLand) {
    return STATE_ORDER
        .filter(key => withBuildingLand || key !== "building_land")
        .map(key => ({ color: STATES[key].color, label: t(STATES[key].label) }));
}
